"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _carousel = require("./carousel");

var _carousel2 = _interopRequireDefault(_carousel);

var _carouselItem = require("./carouselItem");

var _carouselItem2 = _interopRequireDefault(_carouselItem);

var _reactCustomScrollbars = require("react-custom-scrollbars");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GreedyCarousel = function (_React$Component) {
    _inherits(GreedyCarousel, _React$Component);

    function GreedyCarousel() {
        _classCallCheck(this, GreedyCarousel);

        return _possibleConstructorReturn(this, (GreedyCarousel.__proto__ || Object.getPrototypeOf(GreedyCarousel)).apply(this, arguments));
    }

    _createClass(GreedyCarousel, [{
        key: "chunk",
        value: function chunk(myArray, chunk_size) {
            var i = 0;
            var chunk;
            var tempArray = [];

            for (i = 0; i < myArray.length; i += chunk_size) {
                chunk = myArray.slice(i, i + chunk_size);
                tempArray.push(chunk);
            }

            return tempArray;
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                layout = _props.layout,
                perTile = _props.perTile,
                squareStackVertical = _props.squareStackVertical,
                rest = _objectWithoutProperties(_props, ["children", "layout", "perTile", "squareStackVertical"]);

            var w = layout.w,
                h = layout.h;


            var perCarouselItem = Math.max(1, Math.floor(w / h), Math.floor(h / w)) * perTile;

            var chunks = this.chunk(children, perCarouselItem);

            return _react2.default.createElement(
                _carousel2.default,
                _extends({ hideControls: Boolean(chunks.length == 1) }, rest),
                chunks.map(function (chunk, i) {
                    return _react2.default.createElement(
                        _carouselItem2.default,
                        { key: i },
                        chunk.map(function (child, i) {
                            var size = 100 / chunk.length + "%";
                            return _react2.default.createElement(
                                _reactCustomScrollbars.Scrollbars,
                                {
                                    autoHide: true,
                                    key: i,
                                    style: squareStackVertical && w > h || !squareStackVertical && w >= h ? {
                                        float: "left",
                                        position: "relative",
                                        height: "100%",
                                        width: size
                                    } : {
                                        position: "relative",
                                        width: "100%",
                                        height: size
                                    }
                                },
                                child
                            );
                        })
                    );
                })
            );
        }
    }]);

    return GreedyCarousel;
}(_react2.default.Component);

_carousel2.default.PropTypes = {
    /** Optional: show more items per tile. */
    perTile: _propTypes2.default.number,
    /** The parent layout */
    layout: _propTypes2.default.object,
    /** If Tile is square but has more than one item showing, use squareStackVertical if you want items to stack vertically. */
    squareStackVertical: _propTypes2.default.bool
};

GreedyCarousel.defaultProps = {
    rows: 1,
    columns: 1,
    perTile: 1,
    layout: { w: 1, h: 1 },
    squareStackVertical: false
};

exports.default = GreedyCarousel;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/carousel/greedyCarousel.js
// module id = 992
// module chunks = 95715928098905 168707334958949